import I18NUtils from '../i18n/I18NUtils';
export default class NumberUtils {
    static toBoolean(value) {
        return value !== 0;
    }
    ;
    static compare(value1, value2) {
        if (value1 === undefined && value2 === undefined) {
            return 0;
        }
        else if (value1 === undefined && value2 !== undefined) {
            return -1;
        }
        else if (value1 !== undefined && value2 === undefined) {
            return 1;
        }
        else if (value1 < value2) {
            return -1;
        }
        else if (value1 > value2) {
            return 1;
        }
        else {
            return 0;
        }
    }
    ;
    static ensureValid(value, valueIfInvalid = undefined) {
        if (!NumberUtils.isNumber(value)) {
            return valueIfInvalid;
        }
        else {
            return value;
        }
    }
    ;
    static isNumber(obj) {
        return obj !== undefined && obj !== null && (typeof (obj) === 'number' || obj instanceof Number) && !isNaN(obj) && isFinite(obj);
    }
    ;
    static parse(value) {
        return I18NUtils.defaultNumberParser.parse(value);
    }
    ;
    static tryParse(value, valueOnFailure = undefined) {
        return I18NUtils.defaultNumberParser.tryParse(value, valueOnFailure);
    }
    ;
}
//# sourceMappingURL=NumberUtils.js.map